/**
 * A2P Brand Constants
 */
export const RESTRICTED_TCR_ID = 'BUHHI15'

